import { AutogenLayoutCustomerSummary } from "./autogen/AutogenLayoutCustomerSummary";

export class CustomerSummary extends AutogenLayoutCustomerSummary {
    private _customerId: string;

    onLoad(): void | Promise<void> {
        this.textboxLastCompletedActivity.quickInfoOverrideSearchMethod = async (layout, keyValue) => {
            if (!this.activeRow.isNull(this.textboxLastCompletedActivity.field)) {
                await layout.search({ "id": this.activeRow.get("id"), "type": "C" });
            }
        }
    }

    get customerId(): string {
        return this._customerId;
    }
    
    set customerId(value: string) {
        this._customerId = value;
        this.sourceCustomerSummary.search({"id": value});
    }
}